import Guest from "./guest";
class Guests {
  constructor(guests = []) {
    this.guests = [];
    if (guests) {
      for (let i = 0; i < guests.length; i++) {
        this.newGuest(guests[i]);
      }
    }
  }

  newGuest(obj) {
    let g = new Guest();
    g.setData(obj);
    this.guests.push(g);
    return g;
  }

  addEmptyByNumber(numberOfGuests, default_obj = null) {
    for (let i = 0; i < numberOfGuests; i++) {
      let g = new Guest();
      if (default_obj) g.setData(default_obj);
      this.guests.push(g);
    }
    return this.guests;
  }

  UpdateByNumber(id, obj) {
    let guest = this.guests[id];
    if (guest) {
      guest.setData(obj);
      this.guests[id] = guest;
      return guest;
    } else {
      console.error("not found guest by index", id, obj);
    }

    return null;
  }

  allGuests() {
    return this.guests;
  }

  numberOfGuests() {
    return (
      this.allGuests().reduce(
        (count, guest) => count + 1 + [...guest.children].length,
        0
      ) || 0
    );
  }
}

export default Guests;
